module.exports = __webpack_public_path__ + "img/garage_full.616a9b63.jpg";